class AnalyticsController {
  constructor(AnalyticsService, $q) {
    "ngInject"

    this.analyticsService = AnalyticsService;
    this.$q = $q;
  }

  $onInit() {
    this.isLoading = true;

    const getDataSetsPromise = this.analyticsService.getDataSets();

    this.$q.all([getDataSetsPromise]).then(data => {

      const [getDataSetsResponse] = data;

      this.setDataSetsOptions(getDataSetsResponse);

      this.isLoading = false;
    })

  }

  setDataSetsOptions(set) {
    this.registrationsOverTimeGridOptions = this.getGridOptions(set[0]);
    this.approvalsOverTimeGridOptions = this.getGridOptions(set[1]);
    this.helperApprovalsOverTimeGridOptions = this.getGridOptions(set[17]);

    this.firstTimePayingCustomersGridOptions = this.getGridOptions(set[2]);
    this.organicFirstTimePayingCustomersGridOptions = this.getGridOptions(set[3]);
    this.paidFirstTimePayingCustomersGridOptions = this.getGridOptions(set[4]);

    this.recurringPayingCustomersGridOptions = this.getGridOptions(set[5]);
    this.aggregateTotalsGridOptions = this.getGridOptions(set[6]);

    this.organicFirstTimePayingCustomersRevenueGridOptions = this.getGridOptions(set[7]);
    this.paidFirstTimePayingCustomersRevenueGridOptions = this.getGridOptions(set[8]);

    this.firstTimePayingCustomersSummaryGridOptions = this.getGridOptions(set[9]);
    this.firstTimePayingCustomersRevenueSummaryGridOptions = this.getGridOptions(set[10]);

    this.recurringPayingCustomersSummaryGridOptions = this.getGridOptions(set[11]);
    this.recurringPayingCustomersRevenueSummaryGridOptions = this.getGridOptions(set[12]);

    this.auFamilyRegistrationsBySource = this.getGridOptions(set[13]);
    this.nzFamilyRegistrationsBySource = this.getGridOptions(set[14]);
    this.auHelperRegistrationsBySource = this.getGridOptions(set[15]);
    this.nzHelperRegistrationsBySource = this.getGridOptions(set[16]);
    this.registrationsByCountry = this.getGridOptions(set[18]);

    // this.firstTimeQSPayingCustomersGridOptions = this.getGridOptions(set[4]);
    // this.firstTimeASPayingCustomersGridOptions = this.getGridOptions(set[5]);
    // this.redemptionsGridOptions = this.getGridOptions(set[6]);
  }

  getGridOptions(set) {
    let data = set.data;
    let columns = set.dataInfo;
    columns[0].width = "250px";

    return {
      dataSource: {
          data: data,
          pageable: false
      },
      columns: columns,
      scrollable: false,
      sortable: false,
      filterable: false,
    }
  }
}

export default AnalyticsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-data/analytics-data.controller.js
 **/